import React from 'react'

export default function AddressCard() {
  return (
    <div>

    <div className='space-y-3'>
      <p className='font-semibold'>Trung Kiên</p>
      <p> 153AB Nam kỳ khởi nghĩa, P.Võ thị sáu, Q.3, Tp.HCM</p>
      <div className='space-y-1'>
        <p className='font-semibold'>Điện Thoại</p>
        <p>0937789076</p>
      </div>
    </div>

    </div>
  )
}
